import { createContext, useContext, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import io from "socket.io-client";
import { socketUrl } from "../config/apiUrl";
import { setUnReadNotificationCount } from "@/store/common/commonSlice";
import { useDispatch } from "react-redux";

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
  const { isLogin, access_token } = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  const socketRef = useRef(null);

  useEffect(() => {
    if (isLogin) {
      socketRef.current = io(socketUrl, {
        query: { app: "chemlance" },
        auth: { token: access_token },
        transports: ["websocket"],
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        randomizationFactor: 0,
      });
    }
    // new notification
    socketRef.current?.on("new-notification", ({ unreadCount }) => {
      dispatch(setUnReadNotificationCount(unreadCount));
    });
    return () => {
      socketRef.current?.off("new-notification");
      socketRef.current?.disconnect();
    };
  }, [isLogin, access_token]);

  return (
    <WebSocketContext.Provider value={socketRef}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => useContext(WebSocketContext);
